import React from 'react';
import { connect } from 'react-redux';

import GuideSectionItem from './guideSectionItem/guideSectionItem';

import './guideSectionsIndex.scss';

class GuideSectionsIndex extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            prompts,
            filteredResults,
            assessment
        } = this.props;

        const promptIds = Object.keys(prompts);

        return (
            <ul className='sections-display'>
                {
                    promptIds.length > 0 ? 
                        promptIds.map(id => (
                            <GuideSectionItem
                                key={id}
                                promptId={id}
                                prompt={prompts[id]}
                                acceptedFilters={prompts[id].filters.map(filter => filter.tag)}
                                config={prompts[id].resultSectionConfig}
                                filteredResults={filteredResults}
                                assessmentInfo={assessment}
                            />
                        )) 
                        : null
                }
            </ul>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        assessment: state.app.assessment,
        prompts: state.entities.prompts,
        filteredResults: state.session.filteredResults
    };
};

export default connect(mapStateToProps, null)(GuideSectionsIndex);